<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">

    export const PurchaseButtonDefaults = {
        "name": "purchaseButton",
        "outer-container": {
            "style": {
                "padding-top": "17px",
                "padding-bottom": "0px",
            }
        },

        "text": {
            "name": "text",
            "data-pw-purchase": "primary",
            "style": {
                "background-color": "black",
                "color": "white",
                "align-items": "center",
                "justify-content": "center",
                "text-align": "center",
                "width": "100%",
                "height": "65px",
                "font-size": "1.1rem",
                "border-radius": "20px",
                "display": "flex"
            },
            "innerText": "Subscribe"
        },
        "meta": {
            "order": {
                "text": 0
            }
        }
    }
    
</script>

<script>

</script>

<p data-i-name="text"/>
<!-- <button on:click="{alert('test')}"> test </button> -->

<style>

</style>